import { toast } from "react-hot-toast";
import { Tooltip } from "react-tooltip";

import { Button } from "components/ui/Button";
import { useHealthlinkCredentials } from "features/healthlink/hooks/useHealthlinkCredentials";
import { useHealthlinkPractice } from "features/healthlink/hooks/useHealthlinkPractice";
import { useProcessNewMessages } from "features/healthlink/hooks/useProcessNewMessages";
import { usePracticeSettings } from "features/practice/hooks/usePracticeSettings";

const TOOLTIP_ID = "process-messages-btn-tooltip";

export const ProcessMessagesButton = ({ title, successMessage }) => {
  const { data: practiceSettings } = usePracticeSettings();
  const { data: healthlinkPractice } = useHealthlinkPractice();
  const { data: healthlinkCredentials } = useHealthlinkCredentials();

  const { mutate: processMessages, isPending } = useProcessNewMessages();

  // HealthLink off → hide every "process/download" action (all share this
  // button + the process endpoint), regardless of its label.
  if (practiceSettings?.healthLink === false) return null;

  const hasCredentials =
    !!healthlinkPractice &&
    Array.isArray(healthlinkCredentials) &&
    healthlinkCredentials.length > 0;

  const disabledReason = isPending
    ? "Processing, please wait…"
    : !hasCredentials
    ? "Healthlink credentials are not configured"
    : null;

  const isDisabled = !!disabledReason;

  const handleClick = () => {
    // No onError: useProcessNewMessages reports a failure itself, with the backend's
    // own reason. A line here would be the second toast for one press.
    processMessages(undefined, {
      onSuccess: () => {
        if (successMessage) toast.success(successMessage);
      },
    });
  };

  return (
    <>
      <span
        data-tooltip-id={TOOLTIP_ID}
        data-tooltip-content={disabledReason ?? undefined}
        style={{ display: "inline-flex" }}
      >
        <Button variant="text" onClick={handleClick} disabled={isDisabled}>
          {isPending ? "Processing…" : title}
        </Button>
      </span>
      <Tooltip id={TOOLTIP_ID} />
    </>
  );
};
